<template>
  <div class="manage-review">
    <a-card
      :bordered="false"
      class="header-solid h-full"
      :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }"
    >
      <template #title>
        <a-row type="flex" align="middle">
          <h6 class="font-semibold m-0">Danh sách review</h6>
          <router-link :to="{ name: 'CreateReview' }">
            <a-button type="primary" class="ml-20">Thêm mới</a-button>
          </router-link>
        </a-row>
      </template>
      <a-table
        :columns="columns"
        :loading="callingAPI"
        :data-source="dataSource"
        :pagination="{
          pageSize: pageSize,
          total: total,
        }"
        @change="handleChange"
        rowKey="id"
      >
        <template slot="status" slot-scope="row">
          <a-switch
            v-model="row.status"
            :loading="row.loadingActive"
            @change="handleUpdate(row)"
          />
        </template>
        <template slot="action" slot-scope="row">
          <a-space>
            <router-link :to="{ name: 'UpdateReview', params: { id: row.id } }">
              <a-button shape="circle" icon="edit" size="small" />
            </router-link>
            <a-popconfirm
              placement="topRight"
              ok-text="Xóa"
              cancel-text="Hủy"
              @confirm="remove(row)"
            >
              <template slot="title">
                <p>Xóa banner {{ row.name }} ??</p>
              </template>
              <a-button
                type="danger"
                shape="circle"
                icon="delete"
                size="small"
              />
            </a-popconfirm>
          </a-space>
        </template>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import {fetchReview, updateReview, deleteReview} from '@/services/landing-page/review'
  export default {
    name: 'ManageReview',
    data() {
      return {
        callingAPI: true,
        pageSize: 1000,
        total: 0,
        dataSource: [],
        columns: [
          {
            title: 'Tên',
            dataIndex: 'name',
            scopedSlots: { customRender: 'title' },
            class: 'font-semibold',
            width: 200
          },
          {
            title: 'Nội dung',
            dataIndex: 'content',
            class: 'font-semibold'
          },
          {
            title: 'Hiển thị',
            scopedSlots: { customRender: 'status' },
            width: 100,
          },
          {
            title: '',
            scopedSlots: { customRender: 'action' },
            width: 50,
          },
        ],
      }
    },
    async beforeMount() {
      await this.loadData()
    },
    methods: {
      async loadData(page) {
        try {
          this.callingAPI = true
          const params = {
            per_page: this.pageSize
          }
          const response = await fetchReview(params)
          this.dataSource = response.data.data.map((d) =>({
            ...d,
            status: d.status === 1,
            loadingActive: false
          }))
          this.total = response.data.total
          this.callingAPI = false
        } catch (error) {
          
        }
      },

      async handleChange(data) {
        await this.loadData(data.current)
      },

      async handleUpdate(row) {
        const index = this.dataSource.findIndex((r) => r.id === row.id)
        this.dataSource[index].loadingActive = true
        try {
          const data = {
            ...row,
            status: row.status ? 1 : 2,
            _method: 'PUT'
          }
          delete data.id
          const response = await updateReview(row.id, data)
          this.dataSource[index].loadingActive = false
          if (response.status === 1) {
            this.$notification.success({
              message: 'Thành công',
              description: 'Cập nhật trạng thái hiển thị thành công.',
            });
          } else {
            this.$notification.error({
              message: 'Thất bại',
              description: 'Cập nhật trạng thái hiển thị thất bại.',
            });
          }
        } catch (error) {
          this.dataSource[index].loadingActive = false
        }
      },

      async remove(row) {
        try {
          this.callingAPI = true
          const response = await deleteReview(row.id, {_method: 'DELETE'})
          if (response.status === 1) {
            this.$notification.success({
              message: 'Thành công',
              description: 'Xóa review thành công',
            });
          } else {
            this.$notification.error({
              message: 'Thất bại',
              description: 'Xóa review thất bại',
            });
          }
          await this.loadData()
          this.callingAPI = false
        } catch (error) {
          this.callingAPI = false
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>